import { localToGlobalForce } from '@scene'
import { formatPointLoadForceKnValue } from 'src/components/scene/LoadMesh/utils'

export const pointLoadForceFormatter = formatPointLoadForceKnValue

export const pointLoadForceValueGetter = (force: Force, domain: Domain) => {
  const globalForce = localToGlobalForce(force, domain)
  const globalForceZ = globalForce.z
  return Math.abs(globalForceZ) < 1.0e-3 ? 0 : globalForceZ
}
